import {ProductNotifyAvailability} from 'modules/product-card/components/ProductNotifyAvailability';
import {ProductPriceBlockMobile} from 'modules/product-card/components/ProductPriceBlockMobile';
import {ProductReceivingMethod} from 'modules/product-card/components/ProductReceivingMethod';
import {ProductRating} from 'modules/product-card/components/ProductRating';
import {ProductRatings} from 'modules/product-card/components/ProductRatings';
import {ProductFeatureList} from 'modules/product-card/components/ProductFeatureList';
import {ProductVintage} from 'modules/products/components/ProductVintage';
import style from './style.module.scss';
import {ILabel, IVintage} from 'modules/products/types';
import ProductGiftBanner from './ProductGiftBanner';
import ProductOnlineOnlyBanner from 'modules/product-card/pages/ProductPage/ProductOnlineOnlyBanner';
import {ProductSimilarBlock} from 'modules/product-card/pages/ProductPage/ProductSimilarBlock';
import {ISimilar, IProduct} from 'modules/product-card/models/ProductResponse';
import {WishlistButton} from 'modules/wishlist_new/components/WishlistButton';
import YandexSplitWidget from 'modules/product-card/components/YandexSplitWidget/YandexSplitWidget';
import {FC} from 'react';
import ProductGrowingDiscountBanner from 'modules/product-card/pages/ProductPage/ProductGrowingDiscountBanner';

interface IGiftBannerData {
    isShowBanner: boolean;
    title: string;
    url: string;
    imageUrl: string | null;
}

interface IProps {
    isShowNotifyAvailability: boolean;
    isFineAndRareCategory: boolean;
    isOnlineOnly: boolean;
    shouldShowVintages: boolean;
    vintages?: IVintage[];
    code?: string;
    giftBanner: IGiftBannerData;
    similar?: ISimilar;
    id?: IProduct['id'];
    yandexSplitInformer?: IProduct['yandexSplitInformer'];
    growingDiscountBanner?: ILabel;
}

// eslint-disable-next-line complexity
const ProductMobileBlock: FC<IProps> = ({
    isShowNotifyAvailability,
    isFineAndRareCategory,
    shouldShowVintages,
    vintages = [],
    isOnlineOnly,
    code = '',
    giftBanner,
    similar,
    id,
    yandexSplitInformer,
    growingDiscountBanner,
}) => (
    <div className={style.contentMobile}>
        {id && <WishlistButton id={id} />}
        <div>
            {isShowNotifyAvailability ? (
                <>
                    {'vintage' !== similar?.type && <ProductNotifyAvailability withButton={Boolean(similar)} />}
                    <div className={style.similarWrapper}>
                        {similar && <ProductSimilarBlock product={similar.product} type={similar.type} />}
                    </div>
                </>
            ) : (
                <>
                    <ProductPriceBlockMobile />
                    {isOnlineOnly && <ProductOnlineOnlyBanner />}
                    {growingDiscountBanner && <ProductGrowingDiscountBanner {...growingDiscountBanner} />}
                    {giftBanner.isShowBanner && (
                        <ProductGiftBanner
                            title={giftBanner.title}
                            url={giftBanner.url}
                            imageUrl={giftBanner.imageUrl}
                        />
                    )}
                    <ProductReceivingMethod />
                    {yandexSplitInformer && <YandexSplitWidget yandexSplitInformer={yandexSplitInformer} />}
                </>
            )}
        </div>
        <div className={style.contentMobileInfo}>
            {!isFineAndRareCategory && <ProductRating />}
            <ProductRatings />
            {!isFineAndRareCategory && <ProductFeatureList />}
            {shouldShowVintages ? <ProductVintage items={vintages} parentCode={code} /> : null}
        </div>
    </div>
);

export default ProductMobileBlock;
